module.exports = __webpack_public_path__ + "img/tarj-6.f108753c.svg";